import { Link, graphql } from "gatsby"
import React from "react"
import Card from "../components/Card"
import GeneralLayout from "../layouts/GeneralLayout"
import "../styles.css"

const About = props => {
  let data = props.data.allContentfulCertifications.edges

  return (
    <GeneralLayout>
      <div className="aboutWrap">
        <div className="row">
          <div className="col-md-1"></div>
          <div className="col-md-5">
            <h1>a little about me</h1>
            <div className="lineUnder"></div>
            <br />
            <p
              style={{
                fontWeight: "lighter",
                fontSize: "1.5em",
              }}
            >
              Amir is a Pakistan based developer. He has been working for years
              with clients on different platforms and has completed many
              projects. He has experience in working with both foreign and local
              clients. He has got experience working in both frontend and
              backend technologies, he's also good in working with Cloud Native
              technologies. He's a very quick learner and adapts to new
              technology very fast. He's always looking for continuos career
              growth and don't settle for less. Have a look at some of his{" "}
              <Link to="/skills">
                <span className="skillLink">skill set</span>
              </Link>
              .
            </p>
          </div>
          <div className="col-md-1"></div>
          <div className="col-md-4">
            <h3>Education</h3>
            <br />
            <h4>Bachelor of Science in Computer Science</h4>
            <h6>COMSATS University, Islamabad</h6>
            <br />
            <h3>Language</h3>
            <br />
            <h4>
              Urdu/Hindi <span style={{ fontSize: "0.5em" }}>(Native)</span>{" "}
            </h4>
            <h4>
              English <span style={{ fontSize: "0.5em" }}>(Fluent)</span>{" "}
            </h4>
            <h4>
              Spanish{" "}
              <span style={{ fontSize: "0.5em" }}>(Learning)</span>{" "}
            </h4>
            <h4>
              French{" "}
              <span style={{ fontSize: "0.5em" }}>(Learning)</span>{" "}
            </h4>
            <br />
            <h3>Hobbies and Interests</h3>
            <br />
            <h4>
              Travel, Food, Ancient History, Space Exploration, Learning
              Languages, Netflix, Youtube
            </h4>
          </div>

          <div className="col-md-1"></div>
        </div>
        <br />
        <div className="row">
          <div className="col-md-1"></div>
          <div className="col-md-11">
            <h1>Certifications</h1>
            <div className="lineUnder"></div>
            <div className="container">
              <div className="row">
                {data.map(node => (
                  <div className="col-md-4">
                    <Card
                      name={node.node.name}
                      link={node.node.link}
                      tools={node.node.tools}
                      img={node.node.image.fluid.src}
                      description={node.node.description}
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </GeneralLayout>
  )
}

export default About

export const query = graphql`
  query {
    allContentfulCertifications {
      edges {
        node {
          name
          description
          link
          image {
            fluid {
              src
            }
          }
        }
      }
    }
  }
`
